var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wizard__fields-container sw-form"},_vm._l((_vm.fields),function(field,k){return _c('div',{key:k},[_c('inquiry-field',{attrs:{"field":field,"marketingType":_vm.marketingType},on:{"update":_vm.update}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }